(() => {
  if (window.giorgioCartA11yInitialized) return;
  window.giorgioCartA11yInitialized = true;
  let drawer;
  let classObserver;
  let active = false;
  let opener;
  let pointerOpener;
  let background = [];
  let announcementTimer;
  const triggers = () => [...document.querySelectorAll('[data-cart-toggle],[aria-controls="cart-drawer"]')].filter(element => !drawer?.contains(element));
  const anotherDialogIsOpen = () => [...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')].some(element => element !== drawer && !drawer?.contains(element) && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  const visibleFocusables = () => [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')].filter(element => !element.closest('[inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  const focusClose = () => {
    const close = drawer.querySelector('[data-cart-drawer-close]');
    (close || visibleFocusables()[0] || drawer).focus({preventScroll:true});
  };
  const isolateBackground = () => {
    background = [];
    let branch = drawer;
    while (branch.parentElement && branch.parentElement !== document.documentElement) {
      [...branch.parentElement.children].forEach(sibling => {
        if (sibling === branch || ['SCRIPT','STYLE','LINK','TEMPLATE'].includes(sibling.tagName) || sibling.inert) return;
        background.push(sibling);
        sibling.inert = true;
      });
      branch = branch.parentElement;
    }
  };
  const releaseBackground = () => {
    background.forEach(element => { if (element.isConnected) element.inert = false; });
    background = [];
  };
  const updateTriggers = expanded => triggers().forEach(trigger => {
    trigger.setAttribute('aria-controls','cart-drawer');
    trigger.setAttribute('aria-haspopup','dialog');
    trigger.setAttribute('aria-expanded',String(expanded));
  });
  const open = () => {
    if (!drawer || active) return;
    active = true;
    const focused = document.activeElement;
    const remembered = window.accessibility?.lastElement;
    opener = pointerOpener?.isConnected ? pointerOpener : focused && focused !== document.body && !drawer.contains(focused) ? focused : remembered?.isConnected && !drawer.contains(remembered) ? remembered : triggers()[0];
    pointerOpener = null;
    if (window.accessibility && opener) window.accessibility.lastElement = opener;
    drawer.inert = false;
    drawer.removeAttribute('aria-hidden');
    updateTriggers(true);
    isolateBackground();
    requestAnimationFrame(() => {
      if (active && drawer?.classList.contains('is-open') && !anotherDialogIsOpen()) focusClose();
    });
  };
  const close = () => {
    if (!drawer || !active) return;
    active = false;
    releaseBackground();
    updateTriggers(false);
    drawer.inert = true;
    queueMicrotask(() => {
      if (active || !drawer?.isConnected) return;
      if (!anotherDialogIsOpen()) {
        const target = opener?.isConnected && !opener.closest('[inert]') ? opener : triggers()[0];
        target?.focus({preventScroll:true});
      }
      drawer.setAttribute('aria-hidden','true');
    });
  };
  const requestClose = () => {
    if (!active || anotherDialogIsOpen()) return;
    if (typeof drawer.closeCartDrawer === 'function') drawer.closeCartDrawer();
    else document.dispatchEvent(new CustomEvent('theme:cart:toggle',{bubbles:true}));
  };
  const announceCart = event => {
    clearTimeout(announcementTimer);
    announcementTimer = setTimeout(() => {
      const status = document.querySelector('[data-g-cart-page-status]') || drawer?.querySelector('[data-g-cart-status]');
      if (!status) return;
      const count = Number(event.detail?.cartCount);
      if (!Number.isFinite(count)) return;
      const surface = document.querySelector('[data-cart-page]') || drawer;
      const price = surface?.querySelector('[data-cart-total]')?.textContent.trim();
      status.textContent = count === 0 ? status.dataset.cartEmptyLabel : status.dataset.cartUpdated && price ? status.dataset.cartUpdated.replace('__COUNT__', String(count)).replace('__SUBTOTAL__', price) : `${status.dataset.cartTitle} · ${status.dataset.cartItemsLabel}: ${count}${price ? ` · ${status.dataset.cartSubtotalLabel}: ${price}` : ''}`;
    }, 100);
  };
  const bind = () => {
    const next = document.getElementById('cart-drawer');
    if (!next || next === drawer) return;
    if (active) close();
    classObserver?.disconnect();
    drawer = next;
    drawer.setAttribute('role','dialog');
    drawer.setAttribute('aria-modal','true');
    drawer.setAttribute('aria-labelledby','GiorgioCartTitle');
    drawer.tabIndex = -1;
    updateTriggers(false);
    if (drawer.classList.contains('is-open')) open();
    else { drawer.inert = true; drawer.setAttribute('aria-hidden','true'); }
    classObserver = new MutationObserver(() => {
      if (drawer.classList.contains('is-open')) open();
      else close();
    });
    classObserver.observe(drawer,{attributes:true,attributeFilter:['class']});
  };
  document.addEventListener('click',event => {
    const trigger = event.target.closest('[data-cart-toggle],[aria-controls="cart-drawer"]');
    if (trigger && !drawer?.contains(trigger)) {
      pointerOpener = trigger;
      if (trigger.closest('[data-g-header]') && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && typeof drawer?.openCartDrawer === 'function') {
        event.preventDefault();
        if (window.accessibility) window.accessibility.lastElement = trigger;
        drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
      }
    }
    if (event.target.closest('[data-cart-drawer-close]') && drawer?.contains(event.target)) {
      event.preventDefault();
      requestClose();
    }
  },true);
  document.addEventListener('keydown',event => {
    if (!active || !drawer || anotherDialogIsOpen()) return;
    if (event.key === 'Escape') { event.preventDefault(); requestClose(); return; }
    if (event.key !== 'Tab') return;
    const elements = visibleFocusables();
    const first = elements[0];
    const last = elements[elements.length-1];
    if (!first) { event.preventDefault(); drawer.focus(); return; }
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      event.stopPropagation();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      event.stopPropagation();
      first.focus();
    }
  },true);
  document.addEventListener('focusin',event => {
    if (active && drawer && !drawer.contains(event.target) && !anotherDialogIsOpen()) focusClose();
  });
  document.addEventListener('theme:cart-drawer:open',() => { bind(); open(); });
  document.addEventListener('theme:cart-drawer:close',close);
  document.addEventListener('theme:cart:change',announceCart);
  document.addEventListener('shopify:section:load',bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',bind,{once:true});
  else bind();
})();
